import { DemandPrice, IDemandPrice } from './DemandPrice';
import { SortingService } from '@lib/util';

export interface IProductPriceDto {
    unitPrice: string;
    currency: string;
    taxRate: string;
    taxAmount: string;
    linePrice: string;
}

export enum DemandAdditionalCostType {
    DELIVERY_COST = 'DELIVERY_COST',
}

export interface IDemandItemAdditionalCost {
    id: string;
    type: DemandAdditionalCostType;
    name: string;
    supplierArticleNumber: string;
    price: IProductPriceDto;
    taxInPercent: string;
}

export interface IDemandAdditionalCostInfo {
    additionalCosts: IDemandItemAdditionalCost[];
    price: IDemandPrice[];
}

export class DemandItemAdditionalCost {
    id: string;
    type: DemandAdditionalCostType;
    name: string;
    supplierArticleNumber: string;
    price: IProductPriceDto;
    taxInPercent: number;
    constructor(data: IDemandItemAdditionalCost) {
        this.id = data.id;
        this.type = data.type;
        this.name = data.name;
        this.supplierArticleNumber = data.supplierArticleNumber;
        this.price = data.price;
        this.taxInPercent = +data.taxInPercent;
    }
}

export class DemandItemAdditionalCostInfo {
    additionalCosts: DemandItemAdditionalCost[];
    price: IDemandPrice[];

    constructor(data: IDemandAdditionalCostInfo) {
        this.additionalCosts = data.additionalCosts.map(
            (additionalCost) => new DemandItemAdditionalCost(additionalCost),
        );
        this.price = data.price.map((price) => DemandPrice.fromDto(price));

        SortingService.sort(this.additionalCosts, (cost) => cost.name.toLowerCase());
    }
}
